import React, { useEffect } from 'react';
import styles from './PaymentOption.module.scss';
// import OutlineTextInput from "../../components/input/OutlineTextInput";
import { useDispatch, useSelector } from 'react-redux';
// import Button from "../../components/button/Button";
import { Post } from '../../api/client';
import { ReactComponent as ArrowIcon } from '../../assets/images/arrow-left.svg';
import { ReactComponent as BankPaymentIcon } from '../../assets/images/bankpayment.svg';
import { ReactComponent as MasterCardIcon } from '../../assets/images/card-brand-logos/mastercard.svg';
import { ReactComponent as VerveCardIcon } from '../../assets/images/card-brand-logos/verve.svg';
import { ReactComponent as VisaCardIcon } from '../../assets/images/card-brand-logos/visa.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg';
import { ReactComponent as CreditCard } from '../../assets/images/credit-card.svg';
import { ReactComponent as QRcodeIcon } from '../../assets/images/qr-code.svg';
import { ReactComponent as TransferIcon } from '../../assets/images/transfer.svg';
import { ReactComponent as USSD } from '../../assets/images/ussd.svg';
import Banks from '../../components/Banks/Banks';
import DebitCard from '../../components/DebitCard/DebitCard';
import PoweredBy from '../../components/PoweredBy/PoweredBy';
import QrCode from '../../components/QrCode/QrCode';
import Transfer from '../../components/Transfer/Transfer';
import Ussd from '../../components/Ussd/Ussd';
import { ToastErrorStyles } from '../../constants/toastStyles';
import { saveOrderFeeAction } from '../../redux/actions/orderfee/orderFeeAction';
import { openToastAndSetContent } from '../../redux/actions/toast/toastActions';

const PaymentOption = () => {
  interface initTypes {
    CardNumber?: number;
    MonthAndYear?: string;
    Cvv?: string;
    Note?: string;
    DebitCard?: string;
    Bank?: string;
    Transfer?: string;
    Ussd?: string;
    Mobile?: string;
    QRCode?: string;
  }

  const initProps: initTypes = {
    CardNumber: 0,
    MonthAndYear: '',
    Cvv: '',
    DebitCard: 'debit card',
    Bank: 'bank',
    Transfer: 'transfer',
    Ussd: 'ussd',
    Mobile: 'Mobile',
    QRCode: 'qrcode',
  };

  const dispatch = useDispatch();
  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);
  const reference = orderDetails?.data?.order?.reference;
  const amount = orderDetails?.data?.order?.amount;
  const currency = orderDetails?.data?.order?.currency;
  const paymentReference = orderDetails?.data?.order?.paymentReference;
  const otherpaymentmethods = orderDetails?.data?.otherPaymentOptions;
  const savedCards = orderDetails?.data?.savedCards || [];

  const [inputs, setInputs] = React.useState(initProps);

  const [selectedValue, setSelectedValue] = React.useState('');
  const [showPaymentOption, setShowPaymentOption] = React.useState(true);

  const MapPaymentMethod = (valuee: string) => {
    valuee = valuee.toLowerCase();
    return valuee == 'debit card'
      ? 'C'
      : valuee == 'transfer'
      ? 'BANK-TRANSFER'
      : valuee == 'ussd'
      ? 'USSD'
      : valuee == 'bank'
      ? 'BA'
      : valuee == 'qrcode'
      ? 'NQR'
      : 'C';
  };
  const GetOrderFee = async (valuee: string) => {
    if (!amount) return;
    try {
      const pmethod = MapPaymentMethod(valuee ?? 'C');
      const payload = {
        amount: amount,
        currency: currency,
        paymentOption: pmethod,
      };
      const res: any = await Post('order/fee', payload);
      dispatch(saveOrderFeeAction({ data: res.data.data }));
    } catch (error: any) {
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        })
      );
    }
  };

  useEffect(() => {
    GetOrderFee(selectedValue).finally();
  }, [amount]);

  const handleChange = (valuee: string) => {
    console.log(valuee);
    setShowPaymentOption(false);
    const allowedmethods = ['debit card', 'ussd', 'qrcode', 'transfer', 'bank'];
    if (!allowedmethods.includes(valuee)) return;
    setSelectedValue(valuee);
    GetOrderFee(valuee).finally();
  };
  const paymentmethods = [
    {
      name: 'DebitCard',
      value: inputs.DebitCard,
      icon: <CreditCard className={styles.selectionIcon} />,
      displayText: 'Card',
      paymentinstruction: 'Please enter your card details',
    },
    {
      name: 'Ussd',
      value: inputs.Ussd,
      icon: <USSD className={styles.selectionIcon} />,
      displayText: 'USSD',
      paymentinstruction: 'Select bank to begin payment',
    },
    {
      name: 'QRCode',
      value: inputs.QRCode,
      icon: <QRcodeIcon className={styles.selectionIcon} />,
      displayText: 'QR Code',
      paymentinstruction: 'Scan QR code to complete your payment',
    },
    {
      name: 'Transfer',
      value: inputs.Transfer,
      icon: <TransferIcon className={styles.selectionIcon} />,
      displayText: 'Bank Transfer',
      paymentinstruction:
        'To complete this transaction, proceed to your bank app and transfer funds to the account below.',
    },
    {
      name: 'Bank',
      value: inputs.Bank,
      icon: <BankPaymentIcon className={styles.selectionIcon} />,
      displayText: 'Bank Account',
      paymentinstruction:
        'Proceed to your bank app to complete this transaction',
    },
  ];
  const getPaymentMethodComponent = () => {
    switch (selectedValue) {
      case inputs.Transfer:
        return <Transfer reference={reference} />;
      case inputs.Ussd:
        return <Ussd reference={reference} />;
      case inputs.QRCode:
        return <QrCode reference={reference} />;
      case inputs.Bank:
        return <Banks reference={reference} />;
      case inputs.DebitCard:
      default:
        return (
          <DebitCard
            saveCards={savedCards}
            amount={amount}
            currency={currency}
            reference={reference}
          />
        );
    }
  };

  const checkIfPaymentMethodEnabled = (method: any): Boolean => {
    // console.log({ method });
    const mapmethod = MapPaymentMethod(method.value);
    // console.log(mapmethod);
    // console.log({ otherpaymentmethods });
    var paymentexist =
      otherpaymentmethods &&
      otherpaymentmethods.find((x: any) => x.code == mapmethod);
    // console.log({ paymentexist });
    return paymentexist;
  };

  const getPaymentMethodOption = (method: any) => {
    return (
      checkIfPaymentMethodEnabled(method) && (
        <div
          key={method.name}
          className={styles.radioSelection}
          id={selectedValue === method.value ? styles.activeradioSelection : ''}
          onClick={() => handleChange(method.value)}
        >
          {method.icon}
          <div className={styles.radioLabel}>{method.displayText}</div>
          {method.displayText == 'Card' && (
            <span className={styles.cardPaymentIcon}>
              <MasterCardIcon /> &nbsp;
              <VisaCardIcon /> &nbsp;
              <VerveCardIcon />
            </span>
          )}
        </div>
      )
    );
  };
  return (
    <div className={styles.payment}>
      {/* <div className={styles.details}>Payment option</div>
      <div className={styles.method}>
        {
          paymentmethods.find((x) => x.value == selectedValue)
            ?.paymentinstruction
        }
      </div> */}
      {/* <ItemSummary /> */}
      <div className={styles.businessForm}>
        <div
          onClick={() => setShowPaymentOption(!showPaymentOption)}
          className={styles.paymentOptionCloseButton}
        >
          {showPaymentOption ? <CloseIcon /> : <ArrowIcon />}
        </div>
        <div className={styles.selectedPaymentOption}>
          {/* {getPaymentMethodOption(
            paymentmethods.find((x) => x.value == selectedValue)
          )} */}
          <div className={styles.details}>
            {/* <p>Checkout</p> */}
            <div className={styles.method}>
              {
                paymentmethods.find((x) => x.value == selectedValue)
                  ?.paymentinstruction
              }
            </div>
          </div>
          <div>{getPaymentMethodComponent()}</div>
          <PoweredBy />
        </div>
        <div
          className={
            styles.paymentmethodOptions +
            ' ' +
            (!showPaymentOption && styles.paymentmethodOptionToggle)
          }
        >
          <div className={styles.formSelection}>
            <div className={styles.paymentOptionWrapper}>
              <p>Choose A Payment Options</p>
            </div>
            <div className={styles.paymentOptionListWrapper}>
              {paymentmethods.map((method) => getPaymentMethodOption(method))}
            </div>
          </div>
        </div>
        <PoweredBy device="mobile" />
      </div>
    </div>
  );
};

export default PaymentOption;
